import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { useDashboardState } from "components/DashboardContext";
import Dashboard from "../../routes/Dashboard";
import LoadingScreen from "../LoadingScreen";
import SignUp from "../SignUp";

const WithUser = () => {
    var { newUser } = useSelector((state) => state.user.info);

    const {
        setSigningState,
    } = useDashboardState();
    // signinState: 0 - initial state, 1 - after new user form, 2 - after animation
    const [{ signinState }, setLoader] = useState({
        signinState: 0,
    });

    useEffect(() => {
        if (signinState === 2) {
            setSigningState(2);
        }
    }, [signinState]);

    return (
        <>
            {signinState == 0 && newUser && (
                <Route path="/" component={() => <SignUp setLoader={setLoader} />} />
            )}

            {signinState == 1 &&
                <LoadingScreen setLoader={setLoader} />
            }

            {(signinState == 0 && !newUser || signinState == 2) && 
                <Dashboard />
            }
        </>
    );
};

export default WithUser;
